import { defineComponent } from "vue";
import moment, { Moment } from "moment";
import { formatDate } from "../../../common/vue-helpers/modifiers/value-modifier";
import { adjustDate } from "../../../common/adjust-date";

export default defineComponent({
    props: {
        startDate: {
            default: null
        },
        endDate: {
            default: null
        }
    },

    data(vm) {
        return {
            todaysDate: new Date(Date.now()) as Date,
            showCalendar: false,
            noVisitDatePicker: null,
            _dpDateFormat: "MM-DD-YYYY",
            formatDate
        };
    },
    emits: ["taskRefresh"],

    async mounted() {
        await this.taskDatePicker(this.$refs.noVisitDatePicker as HTMLElement);
        this.initDateRange();
    },

    methods: {
        toggleCalendar(): void {
            this.showCalendar = !this.showCalendar;
        },
        async taskDatePicker(datepicker: HTMLElement) {
            let myTasksDate: Date = this.todaysDate;

            $(datepicker)
                .datepicker({
                    keyboardNavigation: false,
                    autoclose: true,
                    todayBtn: "linked",
                    maxViewMode: 0
                })
                .datepicker("setDate", moment(myTasksDate).format(this._dpDateFormat))
                .off("changeDate")
                .on("changeDate", (e: DatepickerEventObject) => {
                    this.changeDate(e.date);
                    e.preventDefault();
                    e.stopPropagation();
                });
        },
        async decrementTaskDate(): Promise<void> {
            await this.dateNavigation(-1);
        },
        async incrementTaskDate(): Promise<void> {
            await this.dateNavigation(1);
        },
        async initDateRange() {
            if (!!this.startDate && !!this.endDate) {
                await this.emitTaskRefresh(this.startDate, this.endDate);
                return;
            }

            await this.emitTaskRefresh(this.todaysDate, this.todaysDate);
        },
        async dateNavigation(offset: number) {
            await this.emitTaskRefresh(adjustDate(this.startDate, offset), adjustDate(this.endDate, offset));
        },
        async changeDate(selectedDate: Date) {
            this.emitTaskRefresh(selectedDate, selectedDate);
        },

        async emitTaskRefresh(startDate: Date, endDate: Date) {
            this.$emit("taskRefresh", { startDate, endDate });
            this.myTasksDateChanged(moment(startDate));
        },
        async myTasksDateChanged(newValue: Moment) {
            const newValueDate = newValue.format("l");
            $(this.$refs.noVisitDatePicker).datepicker("update", newValueDate);
        }
    }
});
